import React from 'react';
import HomePage from '../components/HomePage';

const Home: React.FC = () => {
    return (
        <div className="page-content">
            <HomePage />
        </div>
    );
};

export default Home;